/** Lucide's test for props that keep an icon visible to screen readers, which lucide-react doesn't export. */
export function hasA11yProp(props: object): boolean {
    return Object.keys(props).some((prop) => prop.startsWith('aria-') || prop === 'role' || prop === 'title');
}

/** Stricter than `hasA11yProp`, which counts the `null` aria props a Tooltip passes while it gives no name. */
export function hasAccessibleName(props: { 'aria-label'?: unknown; 'aria-labelledby'?: unknown }): boolean {
    return isNotBlank(props['aria-label']) || isNotBlank(props['aria-labelledby']);
}

function isNotBlank(value: unknown): boolean {
    return typeof value === 'string' && value.trim() !== '';
}
